import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type ContestType } from 'src/types/api'

export const useGetSweepstakes = ({ type }: { type: ContestType }) => {
  const get = useTypedApiClient({
    path: '/le-connect/contests/type/{contestType}',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/sweepstakes'],
    queryFn: async () => {
      const { data } = await get({ contestType: type })
      return data
    },
  })
}
